import { render } from "./BoxSummary.vue?vue&type=template&id=d3d2d7f6&scoped=true"
import script from "./BoxSummary.vue?vue&type=script&lang=js"
export * from "./BoxSummary.vue?vue&type=script&lang=js"

import "./BoxSummary.vue?vue&type=style&index=0&id=d3d2d7f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3d2d7f6"]])

export default __exports__